<template>
  <b-row>
    <b-col>
      <b-row style="margin:0 auto" v-if="loading">
        <div class="loader-rolling-local"></div>
      </b-row>
      <b-row class="mb-3 mt-3" v-else>
        <b-col>
          <div v-if="loadedPerson">
            <!-- PRIVATE PERSON -->
            <md-list v-if="personType=='private'">
              <md-list-item>
                <md-icon>account_circle</md-icon>
                <div class="md-list-item-text">
                  <span>{{loadedPerson.givenName | capitalize}} {{loadedPerson.surname | capitalize}}</span>
                  <span>Name</span>
                </div>
              </md-list-item>
              <md-list-item class="md-inset">
                <div class="md-list-item-text">
                  <span>{{getDisplayDate(loadedPerson.dob)}}</span>
                  <span>Date of Birth</span>
                </div>
              </md-list-item>

              <md-list-item class="mt-4">
                <md-icon>location_on</md-icon>
                <div class="md-list-item-text">
                  <span>{{loadedPerson.address}}</span>
                  <span>Address</span>
                </div>
              </md-list-item>

              <md-list-item v-if="loadedPerson.idCode" class="mt-4">
                <md-icon>account_balance</md-icon>
                <div class="md-list-item-text">
                  <span>{{loadedPerson.idCode}}</span>
                  <span>Personal Identification Number</span>
                </div>
              </md-list-item>
              <md-list-item v-if="loadedPerson.ssnTaxNr" class="mt-4">
                <md-icon>account_balance</md-icon>
                <div class="md-list-item-text">
                  <span>{{loadedPerson.ssnTaxNr}}</span>
                  <span>SSN or Tax Number</span>
                </div>
              </md-list-item>

              <md-list-item class="mt-3">
                <md-icon>outlined_flag</md-icon>
                <div class="md-list-item-text">
                  <span>Accociated nationalities</span>
                </div>
              </md-list-item>
              <md-list-item class="md-inset">
                <md-chip
                  v-for="(item, index) in loadedPerson.nationalities"
                  :key="item+index"
                >{{item}}</md-chip>
              </md-list-item>

              <md-list-item>
                <md-icon>alternate_email</md-icon>
                <div class="md-list-item-text">
                  <span>Accociated emails</span>
                </div>
              </md-list-item>
              <md-list-item class="md-inset">
                <md-chip v-for="(item, index) in loadedPerson.emails" :key="item+index">{{item}}</md-chip>
              </md-list-item>

              <md-list-item>
                <md-icon>phone</md-icon>
                <div class="md-list-item-text">
                  <span>Accociated phones</span>
                </div>
              </md-list-item>
              <md-list-item class="md-inset">
                <md-chip v-for="(item, index) in loadedPerson.phones" :key="item+index">{{item}}</md-chip>
              </md-list-item>
            </md-list>

            <!-- JURIDICAL PERSON -->
            <md-list v-if="personType=='juridical'">
              <md-list-item>
                <md-icon>account_balance</md-icon>
                <div class="md-list-item-text">
                  <span>{{loadedPerson.name | capitalize}}</span>
                  <span>Name</span>
                </div>
              </md-list-item>
              <md-list-item class="md-inset">
                <div class="md-list-item-text">
                  <span>{{loadedPerson.regCountry}}</span>
                  <span>Registration Country</span>
                </div>
              </md-list-item>

              <md-list-item v-if="loadedPerson.regNr" class="mt-4">
                <md-icon>account_balance</md-icon>
                <div class="md-list-item-text">
                  <span>{{loadedPerson.regNr}}</span>
                  <span>Registration number</span>
                </div>
              </md-list-item>
              <md-list-item v-if="loadedPerson.vatNr" class="mt-4">
                <md-icon>account_balance</md-icon>
                <div class="md-list-item-text">
                  <span>{{loadedPerson.vatNr}}</span>
                  <span>VAT Number</span>
                </div>
              </md-list-item>

              <md-list-item class="mt-3">
                <md-icon>location_on</md-icon>
                <div class="md-list-item-text">
                  <span>Accociated addresses</span>
                </div>
              </md-list-item>
              <md-list-item class="md-inset">
                <md-chip v-for="(item, index) in loadedPerson.addresses" :key="item+index">{{item}}</md-chip>
              </md-list-item>

              <md-list-item>
                <md-icon>alternate_email</md-icon>
                <div class="md-list-item-text">
                  <span>Accociated emails</span>
                </div>
              </md-list-item>
              <md-list-item class="md-inset">
                <md-chip v-for="(item, index) in loadedPerson.emails" :key="item+index">{{item}}</md-chip>
              </md-list-item>

              <md-list-item>
                <md-icon>phone</md-icon>
                <div class="md-list-item-text">
                  <span>Accociated phones</span>
                </div>
              </md-list-item>
              <md-list-item class="md-inset">
                <md-chip v-for="(item, index) in loadedPerson.phones" :key="item+index">{{item}}</md-chip>
              </md-list-item>
            </md-list>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import {
  getJuridicalPerson,
  getPrivatePerson
} from "@/platform/person/repository/personRepository.js";
import { formatISOShortToDDMonthYYYY } from "@/timeFunctions.js";

export default {
  props: {
    personId: {
      type: String,
      required: true
    },
    personType: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      loading: true,
      loadedPerson: undefined
    };
  },
  watch: {
    personId: function(val, oldVal) {
      if (val && val != oldVal)
        this.getPerson({ id: val, type: this.personType });
    },
    personType: function(val, oldVal) {
      if (val && val != oldVal)
        this.getPerson({ id: this.personId, type: val });
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {},
  created() {
    if (this.personType && this.personId)
      this.getPerson({ id: this.personId, type: this.personType });
  },
  methods: {
    getPerson({ id, type }) {
      this.loading = true;
      var personPromise;
      type == "juridical"
        ? (personPromise = getJuridicalPerson({ id }))
        : (personPromise = getPrivatePerson({ id }));

      personPromise
        .then(person => {
          this.loadedPerson = person;
        })
        .catch(err => {
        })
        .finally(f => {
          this.loading = false;
        });
    },
    getDisplayDate(date) {
      return formatISOShortToDDMonthYYYY(date);
    },
    getDisplayAddress(propAddress) {
      if (!propAddress) return "Unknown";
      var res = "";
      propAddress.municipality
        ? (res += propAddress.municipality + ", ")
        : void 0;
      propAddress.street ? (res += propAddress.street + " ") : void 0;
      propAddress.number ? (res += propAddress.number + " ") : void 0;
      propAddress.apartNumber
        ? (res += "- " + propAddress.apartNumber)
        : void 0;
      return res;
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
@import "../../assets/styles/listing-preview.css";
</style>



// WEBPACK FOOTER //
// src/components/person/personView.vue